import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { MapPin, Star, ShieldCheck, Sparkles, ArrowRight } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const Hero = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [pincode, setPincode] = useState("");

  const checkPin = () => {
    if (pincode.length < 6) { toast({ title: "Enter a valid 6-digit pincode" }); return; }
    toast({ title: "Great news!", description: `Salon@Home is available at ${pincode}. Explore our services!` });
    navigate("/services");
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-secondary via-white to-secondary/60" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-20 grid lg:grid-cols-2 gap-10 items-center">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-white shadow-sm border border-primary/10 px-4 py-1.5 text-sm font-medium text-primary mb-5"><Sparkles className="w-4 h-4 text-accent" /> Gurugram's Premium Salon@Home for Women</span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900">Luxury Salon Services, <br /><span className="text-primary">Right at Your Home</span></h1>
          <p className="mt-5 text-gray-600 text-lg max-w-lg">Transform your home into a serene oasis of beauty. Book <em className="text-primary not-italic font-semibold">BeBlushify</em> — trained beauticians, branded products & pocket-friendly offers across Gurugram.</p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3 max-w-md">
            <div className="flex-1 flex items-center gap-2 bg-white rounded-full border border-gray-200 shadow-sm px-4"><MapPin className="w-5 h-5 text-primary shrink-0" /><Input value={pincode} onChange={(e) => setPincode(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="Enter your pincode" className="border-0 shadow-none focus-visible:ring-0 px-0 h-12 text-base" /></div>
            <Button onClick={checkPin} className="bg-primary hover:bg-primary/90 rounded-full h-12 px-7 text-base font-semibold">Check <ArrowRight className="w-4 h-4 ml-1" /></Button>
          </div>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3">
            <button onClick={() => navigate("/services")} className="text-primary font-semibold hover:underline underline-offset-4">Explore Services →</button>
            <a href="#beauticians" className="text-primary font-semibold hover:underline underline-offset-4">Our Beauticians →</a>
          </div>

          <div className="mt-8 flex flex-wrap gap-6">
            {[{ icon: Star, label: "4.9/5 Rating", sub: "12,500+ reviews" }, { icon: ShieldCheck, label: "Verified Experts", sub: "Trained & tested" }, { icon: Sparkles, label: "Branded Products", sub: "Rica, O3+, Lotus" }].map((s) => (
              <div key={s.label} className="flex items-center gap-2.5"><div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-primary"><s.icon className="w-5 h-5" /></div><div><div className="text-sm font-semibold text-gray-900">{s.label}</div><div className="text-xs text-gray-500">{s.sub}</div></div></div>
            ))}
          </div>
        </div>

        <div className="relative fade-up hidden lg:block">
          <div className="relative grid grid-cols-2 gap-4">
            <div className="space-y-4 mt-8">
              <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" alt="Facial at home" className="rounded-2xl shadow-xl w-full h-56 object-cover" />
              <img src="https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" alt="Manicure" className="rounded-2xl shadow-xl w-full h-40 object-cover" />
            </div>
            <div className="space-y-4">
              <img src="https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" alt="Makeup" className="rounded-2xl shadow-xl w-full h-40 object-cover" />
              <img src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" alt="Massage" className="rounded-2xl shadow-xl w-full h-56 object-cover" />
            </div>
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-xl px-6 py-3 flex items-center gap-3 border border-primary/10"><div className="text-2xl font-extrabold text-primary">48K+</div><div className="text-xs text-gray-600 leading-tight">Happy bookings<br />across Gurugram</div></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
